let _onlineUser = null;

function getUser() {
  if (null == _onlineUser) {
    _onlineUser = JSON.parse(sessionStorage.getItem("MES_LOGIN_USER_BEAN"))
  }
  return _onlineUser;
}

function getToken() {
  return sessionStorage.getItem("MES_LOGIN_USER_TOKEN");
}

function setUser(user) {
  _onlineUser = user;
  sessionStorage.setItem("MES_LOGIN_USER_BEAN", JSON.stringify(user));
}

function setToken(token) {
  sessionStorage.setItem("MES_LOGIN_USER_TOKEN", token);
}


/**
 * 单一权限验证
 * @param pm 权限值
 * @returns {boolean} true：有权限；false：无权限
 */
function checkPermission(pm) {
  var user = getUser();
  if (user) {
    if (pm) {
      return user.permissions.indexOf(pm) != -1;
    } else {
      return true;
    }
  }
  return false;
}

/**
 * 传入的权限中，必须有全部权限才会验证通过
 * @returns {boolean} true：有权限；false：无权限
 */
function checkAllPermission() {
  var user = getUser();
  if (user) {
    let permissions = arguments[0]
    for (var i = 0; i < permissions.length; i++) {
      if (permissions[i]) {
        if (user.permissions.indexOf(permissions[i]) == -1) {
          return false;
        }
      }
    }
    return true;
  }
  return false;
}

/**
 * 传入的权限中，只要有一个权限就验证通过
 * @returns {boolean} true：有权限；false：无权限
 */
function checkAnyPermission() {
  var user = getUser();
  if (user) {
    let permissions = arguments[0];
    let user_permissions=user.permissions;
    for (var i = 0; i < user_permissions.length; i++) {
      if (user_permissions[i]) {
        if (permissions.indexOf(user_permissions[i]) != -1) {
          return true;
        }
      }
    }
  }
  return false;
}

function logout() {
  sessionStorage.removeItem("MES_LOGIN_USER_BEAN");
  sessionStorage.removeItem("MES_LOGIN_USER_TOKEN");
  _onlineUser = null;
}

export default {
  getUser,
  setUser,
  checkPermission,
  checkAllPermission,
  checkAnyPermission,
  logout,
  getToken,
  setToken
}



// WEBPACK FOOTER //
// ./src/common/OnlineUser.js